export default [
    { 
        text    : 'Código interno', 
        value   : 'internal_code',
    },
    { 
        text    : 'producto', 
        value   : 'name',
    },
    { 
        text    : 'Precio de venta', 
        value   : 'sale_price_by_branch_office',
        format  : 'currency',
        align   : 'center',
    },
    { 
        text    : 'Precio de oferta', 
        value   : 'virtual_offer_price',
        format  : 'currency',
        align   : 'center',
    },
]